/**
 * Whether to show keyboard-shortcut hints (⌘K, ↵ select, ↑↓ navigate).
 *
 * False in the phone frame and on a touch-only device: a hint that names a key
 * the person has no key for is desktop wording left on a phone (audit
 * 2026-11-02, #44). A tablet with a keyboard and a mouse or trackpad keeps them.
 */
import { useMobileExperience } from '../mobile/featureFlag';
import { useMediaQuery } from '../mobile/useMediaQuery';

/** A primary pointer that is a finger and cannot hover: a touch screen, no mouse. */
export const TOUCH_ONLY_MEDIA_QUERY = '(hover: none) and (pointer: coarse)';

export function useKeyboardShortcutHints(): boolean {
  const phone = useMobileExperience();
  const touchOnly = useMediaQuery(TOUCH_ONLY_MEDIA_QUERY);
  return !phone && !touchOnly;
}

/** The text with a trailing ⌘K hint taken off ("Search items… ⌘K" → "Search items…"). */
export function withoutShortcutHint(text: string): string {
  return text.replace(/\s*⌘K\s*$/, '');
}
